export const faqData = [
  {
    title: "Encontre passagens aéreas baratas com o Voopter",
    content:
      "Buscando ofertas para suas viagens?\n\nNo Voopter, você compara preços de passagens aéreas e encontra promoções relâmpago para destinos no Brasil e no mundo.\n\nO Voopter reúne opções de diversas companhias aéreas, agências de viagem e sites de milhas em uma única pesquisa multidatas, ajudando você a viajar com o melhor custo-benefício. Planeje seus voos com economia e segurança, encontrando preços que cabem no seu orçamento.",
  },
  {
    title: "Como comparar preços e criar alertas no Voopter",
    content:
      "Com o Voopter, você pode criar alertas personalizados para suas viagens e ser notificado quando os preços caírem.",
  },
  {
    title: "Descubra achados e promoções relâmpago",
    content:
      "As promoções relâmpago do Voopter são uma maneira excelente de economizar em viagens de última hora.",
  },
];
